import {DatePipe, NgForOf, NgIf} from '@angular/common';
import {AfterViewInit, Component, Input, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatMenuModule} from '@angular/material/menu';
import {MatPaginator, MatPaginatorModule} from '@angular/material/paginator';
import {MatTableDataSource, MatTableModule} from '@angular/material/table';
import {MatTooltipModule} from '@angular/material/tooltip';
import {RouterLink} from '@angular/router';
import {CustomizerSettingsService} from "../../../../customizer-settings/customizer-settings.service";
import {ApiService} from "../../../_services/api.service";
import {Endpoints} from "../../../endpoints";
import {DialogService} from "../../../_modal/dialog.service";
import { AbstractControl,FormBuilder,FormGroup,ReactiveFormsModule, ValidationErrors,Validators} from "@angular/forms";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {MatError, MatFormField, MatLabel, MatSuffix} from "@angular/material/form-field";
import {MatInput, MatInputModule} from "@angular/material/input";
import {MatDatepicker, MatDatepickerInput, MatDatepickerToggle} from "@angular/material/datepicker";
import {OverlayContainer} from "@angular/cdk/overlay";
import {MatSort, MatSortModule} from "@angular/material/sort";
import {MatOption} from "@angular/material/autocomplete";
import {MatSelect} from "@angular/material/select";
import {PocService} from "../../../../services/poc-service/poc.service";
import {HandleErrorsService} from "../../../../services/handle-erros/handle.errors.service";
import {ClientsService} from "../../../../services/client-service/clients.service";
import {ShortClientDto} from "../../../_models/client.dtos";
import {MatCheckbox, MatCheckboxChange} from "@angular/material/checkbox";
import {CookieService} from "ngx-cookie-service";
import {ChangeDetectorRef} from '@angular/core';
import { LaboService } from '../../../../services/labo-service/labo.service';
import { AccreditationService } from '../../../../services/acc-service/acc.service';
import { AccDTO } from '../../../_models/AccDTO';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { LaboDTO } from '../../../_models/LaboDTO';
import { MatNativeDateModule } from '@angular/material/core';

@Component({
    selector: 'app-client-poc-list',
    standalone: true,
    providers: [HandleErrorsService, ApiService, Endpoints, DialogService, PocService, ClientsService],

    imports: [
        MatCardModule, MatMenuModule, MatButtonModule, RouterLink, MatTableModule, MatPaginatorModule, NgIf,
        MatTooltipModule, ReactiveFormsModule, MatFormField, MatLabel, MatError, MatInput, MatDatepicker,
        MatDatepickerInput, MatDatepickerToggle, MatNativeDateModule,MatSuffix, MatSortModule, MatInputModule, MatOption, MatSelect, NgForOf, DatePipe, MatCheckbox
    ],
    templateUrl: './acc-list.component.html',
    styleUrl: './acc-list.component.scss'
})
export class AccreditationComponent implements OnInit, AfterViewInit {
    @Input() clientsPoc: any[] = [];
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('editModal') editModal: TemplateRef<any>;
    @ViewChild('viewModal') viewModal: TemplateRef<any>;
    editForm: FormGroup;
    form: FormGroup;
    clientList: ShortClientDto[]
    dataSource = new MatTableDataSource<AccDTO>();
    searchValue: string = ''
    poc?: AccDTO
    loadingTable: boolean = true;
    //  laboratories: LaboDTO[] = []; Tableau pour stocker les laboratoires

    selectedLaboratoryId: number | null = null; // ID du laboratoire sélectionné
    message: string = '';

    displayedColumns: string[] = ['reference', 'organisme', 'dateObtention', 'dateExpiration', 'logo','documentation'];
    columns: string[] = [...this.displayedColumns];

    constructor(
        private cookieService: CookieService,
        private handleErrorsService: HandleErrorsService,
        private pocService: PocService,
        private cdr: ChangeDetectorRef,
        private accService: AccreditationService,
        private clientService: ClientsService,
        private laboratoryService: LaboService,
        private dialogService: DialogService,
        private fb: FormBuilder,
        private modalService: NgbModal,
        public themeService: CustomizerSettingsService,
        private overlayContainer: OverlayContainer,
        private sanitizer: DomSanitizer) {
    }

    ngOnInit(): void {
        this.fetchAccList()
        this.initializeEditForm();
        this.initializeCreateForm()
        this.getColsCookie()
        this.fetchLaboList()
    }

    fetchAccList() {
        this.accService.findAll().subscribe({
          next: (data: AccDTO[]) => {
            console.log(data);
            this.dataSource.data = data;
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
            this.loadingTable = false;
          },
          error: (err) => {
            console.error('❌ Erreur lors de la récupération des POCs:', err);
            this.loadingTable = false;
          }
        });
      }
      
      laboratorie: any[] = [];
      fetchLaboList() {
        this.laboratoryService.findAll().subscribe({
            next: (response) => {
                this.laboratorie = response.data; 
              },
              error: (error) => {
                console.error("Erreur lors de la récupération des matrices :", error);
              }
    })
}
    
      isValidBase64(base64String: string): boolean {
        const regex = /^data:image\/(png|jpeg|jpg|gif);base64,/;
        return regex.test(base64String);
      }

    ngAfterViewInit() {
        this.initializePaginatorAndSort();
    }

    private initializePaginatorAndSort() {
        this.dataSource.filter = this.searchValue
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.sort.active = 'id';
        this.sort.direction = 'asc';
        this.overlayContainer.getContainerElement().style.zIndex = '2000';
    }

    initializeEditForm(acc: any = {  // Valeur par défaut si acc n'est pas passé
        id: '',
        reference: '',
        organisme: '',
        dateObtention: '',
        dateExpiration: '',
        logo: null,
        documentation: 'null'
      }) {
        this.editForm = this.fb.group({
          id: [acc?.id || '', Validators.required],
          reference: [acc?.reference || '', Validators.required],
          organisme: [acc?.organisme || '', Validators.required],
          dateObtention: [acc?.dateObtention || '', Validators.required],
          dateExpiration: [acc?.dateExpiration || '', Validators.required],
          logo: [acc?.logo || null],  // Si logo peut être null, ce n'est pas un champ obligatoire
          documentation: [acc?.documentation || null],
        });
      }
     
    
    initializeCreateForm() {
        this.form = this.fb.group({
            id: ['', Validators.required],
            reference: ['', Validators.required],
            organisme: ['', Validators.required],
            dateObtention: ['', Validators.required],
            dateExpiration: ['', Validators.required],
            logo: [null],  // Logo peut être optionnel, donc pas nécessaire de mettre Validators.required
            documentation:[null],
        });
    }
    public phoneValidator(control: AbstractControl): ValidationErrors | null {
        const validPhonePattern = /^[+\d][\d\s-]*$/;
        return validPhonePattern.test(control.value) ? null : { invalidPhone: true };
    }

    getLaboName(laboratoryId: number): string {
        const client = this.laboratorie.find(labo => labo.id === laboratoryId);
        return client?.raisonSociale ?? 'N/A';  // Utilisation de l'opérateur "??" pour éviter "undefined"
    }

      
    openEditModal(element: AccDTO) {
        this.editForm.patchValue(element);
        this.modalService.open(this.editModal, {ariaLabelledBy: 'modal-basic-title', size: 'lg'});
    }

    


/*    onFileSelected(event: any) {
        const file = event.target.files[0];  // Récupère le fichier
        const reader = new FileReader();
      
        reader.onloadend = () => {
          // Une fois que la lecture du fichier est terminée, récupère l'image en base64
          this.form.patchValue({
            logo: reader.result as string  // L'image sous forme de chaîne base64
          });
        };
      
        if (file) {
          reader.readAsDataURL(file);  // Convertir le fichier en base64
        }
      }
      
  */
      getSafeImageUrl(logo: string): string {
        // Si l'URL commence par 'http', c'est une URL d'image valide
        if (logo && logo.startsWith('http')) {
          return logo; // Renvoie directement l'URL
        }
      
        // Si c'est une chaîne Base64, renvoie l'URL 'data:image/png;base64,...'
        if (logo && logo.startsWith('data:image')) {
          return logo; // Renvoie directement l'image en Base64
        }
      
        // Si aucune image n'est fournie, renvoyer une image par défaut
        return 'https://www.exem.fr/wp-content/uploads/2023/10/Exem-Cofrac.png';  // Logo par défaut
      }
      
      
      saveAcc() {
        let logo = this.form.value.logo ? this.form.value.logo : null; 
        const newParameter = {
            ...this.form.value,
            logo: logo, // Envoi de l'URL du logo ou null
        };

        delete newParameter.laboratoryId;
        
        console.log("Nouvelle accréditation à envoyer:", newParameter);
    
        this.accService.createAcc(newParameter).subscribe({
            next: (response: any) => {
            console.log("Réponse du backend:", response);
            // Le backend retourne directement l'objet, pas un CommonResponse
            if (response && response.id) {
                this.modalService.dismissAll();
                this.cdr.detectChanges(); 
                this.fetchAccList();
            } else {
                console.error("Échec de la création de l'accréditation:", response);
                this.fetchAccList();
            }
        },
            error: (error) => {
                console.error("Erreur lors de la création de l'accréditation:", error);
                this.modalService.dismissAll();
            }
        });
    }
    

        onFileSelected(event: any) {
            const file = event.target.files[0];  // Récupère le fichier
            const reader = new FileReader();
          
            reader.onloadend = () => {
              // Une fois que la lecture du fichier est terminée, récupère l'image en base64
              this.form.patchValue({
                logo: reader.result as string  // L'image sous forme de chaîne base64
              });
            };
          
            if (file) {
              reader.readAsDataURL(file);  // Convertir le fichier en base64
            }
          }
          
      
    /*saveAcc() { 
        const laboId = Number(this.form.get('laboratory')?.value);
            if (!laboId) {
            console.error("Les identifiants du département ou de la formule sont invalides.");
            return;
        }
    
        // Récupérer les objets de la formule et de l'utilisateur
        const laboratory = { id: laboId };  // Récupérer les objets avec leurs IDs, si nécessaire
    
        this.form.patchValue({
            laboratory: laboratory,        
        });
    
+        console.log("Valeurs après patchValue:", this.form.value);
        const newParameter = { ...this.form.value };
    
        delete newParameter.id;
    
        console.log("Nouvelle parameter à envoyer:", newParameter);
        // Appel du service pour créer le paramètre
        this.accService.createAcc(newParameter).subscribe({
            next: (response) => {
                console.log("Réponse du backend:", response);
                if (response.status) {
                    this.modalService.dismissAll(); 
                    this.fetchAccList(); 
                } else {
                    console.error("Échec de la création de la parameter:", response.message);
                    this.fetchAccList(); 
                }
            },
            error: (error) => {
                console.error("Erreur lors de la création de la parameter:", error);
                this.modalService.dismissAll();

            }
        });
    }*/


        saveUpdatedTypeAnalyse() {
            console.log("Formulai de mise à jour soumis :", this.editForm.value);     
            if (this.editForm.invalid) {
                console.error("Le formulaire est invalide", this.editForm.errors);
                // If you want to iterate through all form controls and check errors
            Object.keys(this.editForm.controls).forEach((key) => {
               const control = this.editForm.controls[key]; // Access form control
               if (control && control.invalid) { // Check if control is invalid
               console.log(`Le champ ${key} est invalide`, control.errors); // Display errors
           }
              });
             return; }
            
            const updatedTypeAnalyse = { ...this.editForm.value };
            console.log("Type Analyse mise à jour à envoyer :", updatedTypeAnalyse);
                if (!updatedTypeAnalyse.id) {
                console.error("L'ID du type d'analyse est manquant.");
                return;
            }
        
            this.accService.update(updatedTypeAnalyse.id, updatedTypeAnalyse).subscribe({
                next: (response) => {
                    console.log("Réponse du backend :", response);
                    if (response && response.id) {
                        console.log("✅ Mise à jour réussie !");
                        this.modalService.dismissAll();
                        this.fetchAccList(); 
                    } else {
                        console.error("⚠️ Échec de la mise à jour : Réponse inattendue.", response);
                    }
                },
                error: (error) => {
                    console.error("❌ Erreur lors de la mise à jour du type d'analyse :", error);
                }
            });
            
        }
        
    updatePoc() {
        if (this.editForm.valid) {
            const formData = this.editForm.value;

            this.pocService.update(formData).subscribe({
                next: response => {
                    if (response.status) {
                        this.updateTableRow(response.data)
                        this.modalService.dismissAll()
                        this.dialogService.openSuccessDialog(response.message)
                    } else {
                        this.dialogService.openDangerDialog(response.message)
                    }
                },
                error: err => this.handleErrorsService.catchError(err),
                complete: () => this.initializePaginatorAndSort()
            })
        } else {
            this.dialogService.openInvalidFormDialog()
        }
    }

    updateTableRow(updatedData: any) {
        const index = this.dataSource.data.findIndex(item => item.id === updatedData.id);
        if (index !== -1) {
            this.dataSource.data[index] = updatedData;
            this.dataSource = new MatTableDataSource<any>(this.dataSource.data);
        }
    }

    confirmDelete(element: any) {
        this.dialogService.confirm('Etes-vous sûr de vouloir supprimer cet accreditation?')
            .then((result: any) => {
                if (result) {
                    this.deleteAcc(element.id);
                }
            });
    }
    deleteAcc(id: number) {
        this.accService.delete(id).subscribe({
            next: response => {
                if (response) {
                    this.removeTableRow(id);
                    this.modalService.dismissAll();
                    this.cdr.detectChanges();
                    this.dialogService.openSuccessDialog('Accreditation supprimé avec succès')
                    this.fetchAccList()
                }
            },
            error : err => this.handleErrorsService.catchError(err),
            complete: () => this.initializePaginatorAndSort()
        });
    }

    removeTableRow(id: number) {
        this.dataSource.data = this.dataSource.data.filter(item => item.id !== id);
        this.dataSource = new MatTableDataSource<any>(this.dataSource.data);
    }

    applyFilter(event: Event) {
        this.searchValue = (event.target as HTMLInputElement).value.trim().toLowerCase()
        this.dataSource.filter = this.searchValue
    }

    openViewModel(element:AccDTO ) {
        this.poc = element
        this.modalService.open(this.viewModal, {ariaLabelledBy: 'modal-basic-title', size: 'lg'});

    }
    openModal(content: any) {
        this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title', size: 'lg'}).result.then(
            () => {
                this.form.reset()
            },
            () => {
                this.form.reset()
            }
        );
    }
    handleIsAllColsSelected(event: MatCheckboxChange) {
        if (event.checked) {
            this.displayedColumns = [...this.columns]
        } else {
            this.displayedColumns = []
        }
        this.setColsCookie()
    }

    getdisplayedCol = (): string[] => {
        return [...this.displayedColumns, 'action']
    };
    onSelectionChange(column: string): void {
        if (this.displayedColumns.includes(column)) {
            this.displayedColumns = this.displayedColumns.filter(c => c !== column);
        } else {
            this.displayedColumns.push(column)
        }
        this.setColsCookie()
    }

    user_name = sessionStorage.getItem('user_name');

    private setColsCookie() {
        this.cookieService.set(`poc_${this.user_name}`, JSON.stringify(this.displayedColumns), {
            expires: 7,
            path: '/',
            secure: true
        });
    }
    private getColsCookie() {
        const sampleCols = this.cookieService.get(`poc_${this.user_name}`); // Get the cookie value

        if (sampleCols) {
            this.displayedColumns = JSON.parse(sampleCols); // Convert the JSON string back to an object
            console.log('Retrieved object:', sampleCols);
        }
    }

    
}

